import { render } from "./Statements.vue?vue&type=template&id=1a5759d4&scoped=true"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"

import "./Statements.vue?vue&type=style&index=0&id=1a5759d4&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5759d4"]])

export default __exports__